<template>
  <div class="log-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <div class="nav-title-wrap">
          <span class="nav-devname">{{ udname }}</span>
          <span class="nav-did">设备日志</span>
        </div>
      </template>
    </van-nav-bar>

    <div class="content-area">
      <van-tabs v-model="activeTab" class="crystal-tabs" :swipeable="true" color="#2dd4bf" title-active-color="#2dd4bf" title-inactive-color="#94a3b8">
        <van-tab title="漏水记录">
          <div class="log-card">
            <div class="log-table-header">
              <span class="log-col log-col--val">状态</span>
              <span class="log-col log-col--time">记录时间</span>
            </div>
            <div v-for="(item, i) in leaklist" :key="'leak-' + i" class="log-row">
              <span class="log-col log-col--val">
                <span class="log-tag" :class="item[0] === 1 ? 'log-tag--danger' : 'log-tag--success'">
                  {{ item[0] === 1 ? '水位异常' : '水位正常' }}
                </span>
              </span>
              <span class="log-col log-col--time">{{ item[1] }}</span>
            </div>
            <div v-if="leaklist.length === 0" class="log-empty">暂无记录</div>
          </div>
        </van-tab>
        <van-tab title="输出记录">
          <div class="log-card">
            <div class="log-table-header">
              <span class="log-col log-col--val">状态</span>
              <span class="log-col log-col--time">记录时间</span>
            </div>
            <div v-for="(item, i) in relaylist" :key="'relay-' + i" class="log-row">
              <span class="log-col log-col--val">
                <span class="log-tag" :class="item[0] === 1 ? 'log-tag--active' : 'log-tag--inactive'">
                  {{ item[0] === 1 ? '开' : '关' }}
                </span>
              </span>
              <span class="log-col log-col--time">{{ item[1] }}</span>
            </div>
            <div v-if="relaylist.length === 0" class="log-empty">暂无记录</div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "KA1Log",
  data() {
    return {
      activeTab: 0,
      devdata: null,
      did: this.$route.query.did,
      udname: this.$route.query.udname,
      leaklist: [],
      relaylist: []
    };
  },
  mounted() {
    this.gethistory();
  },
  methods: {
    gethistory() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/history", qs.stringify({
          did: this.did,
          dtype: "KA-1",
          history: "log",
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            var buf = response.data.data.log_buf;
            this.leaklist = buf.leak || [];
            this.relaylist = buf.relay || [];
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}
</style>

<style scoped>
.log-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.crystal-tabs .van-tabs__wrap {
  box-shadow: 0 1px 0 #f1f5f9;
}

.log-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  margin-top: 10px;
}

.log-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.log-card-header span {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.header-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.header-dot--leak {
  background: #2dd4bf;
}

.header-dot--relay {
  background: #a78bfa;
}

.log-table-header {
  display: flex;
  align-items: center;
  background: #f8fafc;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.log-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}

.log-row:last-child {
  border-bottom: none;
}

.log-row:active {
  background: #f8fafc;
}

.log-col {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
}

.log-col--val {
  width: 25%;
  flex-shrink: 0;
}

.log-col--time {
  flex: 1;
  text-align: right;
  color: #94a3b8;
  font-weight: 400;
  font-size: 12px;
}

.log-table-header .log-col {
  font-weight: 600;
  color: #64748b;
  font-size: 12px;
}

.log-table-header .log-col--time {
  color: #64748b;
  font-weight: 600;
}

.log-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
}

.log-tag--success {
  background: rgba(45, 212, 191, 0.12);
  color: #0d9488;
}

.log-tag--danger {
  background: rgba(251, 113, 133, 0.12);
  color: #e11d48;
}

.log-tag--active {
  background: rgba(45, 212, 191, 0.12);
  color: #0d9488;
}

.log-tag--inactive {
  background: rgba(148, 163, 184, 0.15);
  color: #64748b;
}

.log-empty {
  text-align: center;
  padding: 40px 20px;
  font-size: 14px;
  color: #94a3b8;
}
</style>
